module.exports = __webpack_public_path__ + "img/media (22).4a9ee894.png";